import React from 'react'
import { Table } from '@surecompanies/core_components'
import usePayrollApiActivity from './usePayrollApiActivity'
import { columns } from './mapper'
import ClientSelect from 'components/ClientSelect'
import { Select } from 'antd'
import Layout from '../../components/Layout'
import ErrorComponent from '../../components/Error'
import { statusOptions } from './constants'

const { Option } = Select

function PayrollApiActivity() {
  const {
    selectedStatus,
    handleStatusChange,
    selectedClientId,
    handleCompanyChange,
    isPending,
    isError,
    error,
    refetch,
    data,
    handlePaginationChange,
    companyList,
  } = usePayrollApiActivity()

  // Error state
  if (isError) {
    return (
      <Layout title="Payroll API Activity">
        <ErrorComponent retry={refetch} error={error} />
      </Layout>
    )
  }

  return (
    <Layout title="Payroll API Activity">
      <ClientSelect
        allCompaniesPlacholder={{ id: '', companyName: 'All Companies' }}
        companies={companyList}
        defaultCompanyId={''}
        selectedCompanyId={selectedClientId}
        onChange={handleCompanyChange}
      />
      <Select
        showSearch
        placeholder="All Status"
        style={{ width: 200 }}
        onChange={handleStatusChange}
        value={selectedStatus}
      >
        {statusOptions.map(({ id, name }) => (
          <Option key={id} value={id}>
            {name}
          </Option>
        ))}
      </Select>

      <Table
        loading={isPending}
        dataSource={data?.data || []}
        columns={columns as any}
        rowKey={(record) => record.customerName}
        locale={{
          emptyText: isPending ? 'Loading...' : 'No Data',
        }}
        pagination={{
          total: data?.meta?.total,
          showSizeChanger: false,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          current: data?.meta?.page,
          pageSize: 50,
          onChange: handlePaginationChange,
        }}
      />
    </Layout>
  )
}

export default PayrollApiActivity
